import BeCuponUtils from "@/utils/Utils";

export default class CouponWelcomeUser {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        welcomeCouponUserRetrieve(id: ${id}) {
          id
          created
          user {
            id
            email
            profile {
              image {
                url
              }
            }
          }
          welcomeCoupon {
            coupon {
              id
              title
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.welcomeCouponUserRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query {
        welcomeCouponUserList(pageSize: 1000) {
          results {
            id
            created
            user {
              id
              email
              }
              welcomeCoupon {
                coupon {
                  id
                  title
                }
              }              
            }
          }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    for(var i = 0; i < response.data.data.welcomeCouponUserList.results.length; i++) {
      response.data.data.welcomeCouponUserList.results[i].created = BeCuponUtils.formatDateTime(response.data.data.welcomeCouponUserList.results[i].created); 
    }

    return response.data.data.welcomeCouponUserList.results.reverse();
  }
}